import React from "react";
import { useDropzone } from "react-dropzone";
import assetsManager from "../assets/assetsmanager/assestsmanager";

function ImageDropzone({ setFiles, multiSelect, files }) {
  // Handle dropped files
  const onDrop = (acceptedFiles) => {
    // Filter files to only include PNG and SVG formats
    const imageFiles = acceptedFiles.filter(
      (file) => file.type === "image/png" || file.type === "image/svg+xml"
    );

    // End flow if no valid files are selected
    if (imageFiles.length === 0) return;

    // Multi-select or single file flow
    if (!multiSelect) {
      // Only take the first valid file
      setFiles(imageFiles.slice(0, 1));
      return;
    }

    // Fetch already selected file names
    const existingFileNames = files.map((file) => file.name);

    // Filter new files to avoid duplicates
    const newImageFiles = imageFiles.filter(
      (file) => !existingFileNames.includes(file.name)
    );

    // If no new files after filtering, return
    if (newImageFiles.length === 0) return;

    // Add new files to the existing ones
    setFiles((prev) => [...prev, ...newImageFiles]);
  };

  // Destructure hooks from useDropzone
  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  return (
    <div
      {...getRootProps()}
      className={`dropzone bg-[#B73838] rounded-md border-[#B73838] border-dashed border-[1px] flex items-center justify-center flex-col p-6 ${
        isDragActive ? "bg-opacity-20" : "bg-opacity-10"
      }`}
    >
      <input {...getInputProps()} />
      <img src={assetsManager.uploadIconForModal} alt="Upload" />
      <p className="text-md text-[#333333] font-medium mt-4">
        Drag & drop files or{" "}
        <span className="text-[#A83E3E] cursor-pointer">Browse</span>
      </p>
      <p className="text-xs text-[#676767]">
        Supported formats: PNG, SVG
      </p>
    </div>
  );
}

export default ImageDropzone;
